module.exports = __webpack_public_path__ + "img/inspiration_img_1.77a9bd4a.jpg";